<template>
    <div class="main">
        <!-- <div class="main-top-sticky">
      <div class="main-title">
        <span>苏州市吴中区星港街263号加城湖滨公寓5栋3单元1506室</span>
        <div class="main-title-p">监理验收</div>
      </div>
      <div class="main-project-type mt32">
        <div class="main-project-type-content">
          <span>项目类型：</span>
          <span>空调新风壁挂炉(地暖)</span>
        </div>
      </div>
      <div class="main-project-type mt20">
        <div class="main-project-type-content">
          <span>成交金额：</span>
          <span>8100000元</span>
        </div>
      </div>
      <div class="main-project-team">
        <div></div>
        <span>项目团队</span>
      </div>
      <div style="display: flex" class="main-project-type mt20">
        <div class="main-project-type-content">
          <span>签单手：</span>
          <span>刘玉婷</span>
        </div>
        <div class="main-project-type-content">
          <span>项目经理：</span>
          <span>杨团结</span>
        </div>
        <div class="main-project-type-content">
          <span>设计师：</span>
          <span>盛丽花</span>
        </div>
      </div>
      <div style="display: flex" class="main-project-type mt20">
        <div class="main-project-type-content">
          <span>施工队长：</span>
          <span class="wid10">张思</span>
          <span style="color: #a3a3a3">施工队长：</span>
          <span>张思</span>
        </div>
      </div>
      <div class="main-project-evaluate">
        <span>当前客户评价：</span>
        <van-rate
          v-model="evaluate"
          size="0.5rem"
          color="#ffd21e"
          void-icon="star"
          void-color="#eee"
        />
        <span class="mr16" style="color: #a3a3a3; margin-left: auto">详情</span>
        <van-icon size="0.32rem" name="arrow" color="#A3A3A3" />
      </div>
      <div class="main-project-evaluate-label">
        <div>派工申请</div>
        <div>巡检记录</div>
        <div>发货提醒</div>
        <div>转派</div>
      </div>
      <div class="wire"></div>
      <navbar :index="4"></navbar>
      <div class="hei32"></div>
    </div> -->
        <!-- <div v-if="false"> -->
        <div v-if="listShow">
            <div class="main-project-facility">
                <div class="service-box">
                    <span style="color: #a3a3a3">中控器条码：</span><span style="color: #3d3c4f">{{arrTopObj.code}}</span><br />
                    <span style="color: #a3a3a3">设备编码：</span><span style="color: #3d3c4f">{{arrTopObj.dtuid}}</span><br />
                    <span style="color: #a3a3a3">主动服务：</span><span style="color: #3d3c4f">{{arrTopObj.service_open == 1 ? '开启':'关闭'}}</span>
                </div>
                <div class="device-box">
                    <div v-for="(item,index) in arrTopObj.arrDevice" :key="index">
                        <span>{{item.fault_category}}</span>
                        <span v-if="item.device_online == 0" class="dot2"></span>
                        <span v-else class="dot"></span>
                        <span v-if="item.device_online == 0" style="color: red;">关闭</span>
                        <span v-else style="color: #74b176;">开启</span>
                        <!-- 0 关闭 1 打开 -->
                    </div>
                </div>
            </div>
            <div class="wire m32-48"></div>
            <div class="solve">
                <div @click="solveSelect(0)"
                    :style="solve == 0 ? 'background:#0D53FC;color:#ffffff' : 'background:#f3f6ff;color:#0D53FC' ">
                    未解决({{noNumber}})
                </div>
                <div @click="solveSelect(1)"
                    :style=" solve == 1 ? 'background:#0D53FC;color:#ffffff' : 'background:#f3f6ff;color:#0D53FC' ">
                    已解决({{yesNumber}})
                </div>
            </div>
            <template v-if="solveItem.length > 0">
                <template v-for="(item, index) of solveItem">
                    <div :key="index">
                        <div class="solve-project" :style=" item.show == true ? 'border-radius: 0.213333rem 0.213333rem 0 0' : 'border-radius: 0.213333rem 0.213333rem 0.213333rem 0.213333rem' ">
                            <span>{{ item.title }}</span>
                            <span>{{solve == 0 ? '未' : '已'}}解决故障：{{ item.num }}个</span>
                            <van-icon @click="item.show = !item.show" color="#ffffff" size="0.35rem" :name="item.show == false ? 'arrow-down' : 'arrow-up'" />
                        </div>
                        <transition name="navContent" mode="out-in">
                            <div style="border-radius: 0px 0px 0.213333rem 0.213333rem" class="solve-project-content"
                                v-if="item.show">
                                <template v-for="(items, indexs) of item.content">
                                    <div :key="indexs">
                                        <div class="solve-project-content-title">
                                            <div></div>
                                            <!-- <div>{{ items.title }}</div> -->
                                            <div>IOT</div>
                                            <div v-if="items.describe" style="border: 0.026667rem solid #eeb038; color: #eeb038">
                                                {{ items.describe }}
                                            </div>
                                        </div>
                                        <div class="solve-project-content-content">
                                            <span>故障时间：{{items.content.fault_time}}</span>
                                            <!-- <span>服务类型：维修</span> -->
                                            <span>故障类型：{{items.content.fault_type}}</span>
                                            <!-- <span>备注：机器有异响</span> -->
                                        </div>
                                        <div class="solve-project-content-content top2solid">
                                            <span>回馈时间：{{items.content.resolved_time}}</span>
                                            <span>服务单号：{{items.content.iot_order_sn}}</span>
                                            <span>服务队：{{items.content.team}}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </transition>
                        <div class="hei16"></div>
                    </div>
                </template>
            </template>
            <template v-else>
                <img class="empty-img" src="@/assets/images/archives/dossier/contract_not.png" alt="" />
                <div class="not">暂无信息</div>
            </template>
        </div>
        <div class="emty" v-else>
            <img src="@/assets/images/archives/dossier/contract_not.png" alt="">
            <span>暂无信息</span>
        </div>
    </div>
</template>

<script>
    import navbar from "../components/nav_bar/index";
    import oData from "../../../../js/archives/survey/index.js"
    export default {
        components: {
            navbar,
        },
        data() {
            return {
                evaluate: 2,
                active: 1,
                id: "",
                solve: 0,
                solveItem: [],

                contractId: '',
                arrTopObj:{
                    code: '',//中控条形码
                    dtuid: '',//设备编码
                    service_open: '',//主动服务
                    arrDevice: [],//设备是否在线
                },
                resolvedArrList: [],//已解决
                UnesolvedArrList: [],//未解决
                yesNumber: 0,//已解决数量
                noNumber: 0,//未解决数量
                listShow: true,
            };
        },
        created() {
            console.log(this.$route.query.contract_id,'------');
        },
        mounted() {
            this.contractId = this.$route.query.contract_id;
            this.getServiceData()
        },
        methods: {
            solveSelect(index) {
                this.solve = index;
                if(index == 0){
                    this.solveItem = this.UnesolvedArrList
                }else{
                    this.solveItem = this.resolvedArrList
                }
            },
            getServiceData(){
                this.$store.commit("loadSwitch", true);
                oData.archivesList({
                    contract_id: this.contractId,
                    page: 1,
                    limit: 10000,
                }).then(res =>{
                    this.$store.commit("loadSwitch", false);
                    console.log(res);
                    if(res.data.data.result.resolved.num == 0 && res.data.data.result.unresolved.num == 0){
                        this.listShow = false
                        console.log("_+_+_+_+_+_+_+_+_");
                    }
                    //顶部中控数据
                    this.arrTopObj = res.data.data.result.top
                    
                    //已解决数量
                    // this.yesNumber = res.data.data.result.resolved.num
                    res.data.data.result.resolved.list.forEach(it =>{
                        this.yesNumber = this.yesNumber + it.num
                    })
                    
                    //未解决数量
                    // this.noNumber = res.data.data.result.unresolved.num
                    res.data.data.result.unresolved.list.forEach(it =>{
                        this.noNumber = this.noNumber + it.num
                    })
                    //已解决 lists
                    this.resolvedArrList = res.data.data.result.resolved.list.map(it =>{
                        it.show = false
                        return it
                    })
                    //未解决 lists
                    this.UnesolvedArrList = res.data.data.result.unresolved.list.map(it =>{
                        it.show = false
                        return it
                    })
                    this.solveItem = this.UnesolvedArrList
                })
            },
            //数组去重
            objHeavy(arr){
            	let arr1 = []; //存id
            	let newArr = []; //存新数组
            	for(let i in arr){
            		if(arr1.indexOf(arr[i].fault_category) == -1){
            			arr1.push(arr[i].fault_category);
            			newArr.push(arr[i]);
            		}
            	}
            	return newArr;
            }
        },
    };
</script>

<style lang="scss" scoped>
    .emty {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 400px;
        }

        span {
            text-align: center;
            font-size: 28px;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
        }
    }

    .empty-img {
        width: 400px;
        height: 380px;
        display: block;
        margin: 0 auto;
    }

    .not {
        text-align: center;
        color: #999999;
        font-size: 28px;
    }

    .main-top-sticky {
        position: sticky;
        top: 78px;
        width: 100%;
        padding: 32px 32px 0 32px;
        z-index: 10;
        background: #ffffff;
    }

    // .navContent-enter-active,
    // .navContent-leave-active {
    //   transition: all 0.2s;
    // }
    .navContent-enter {
        opacity: 0;
        // transform: translateX(30px);
    }

    .navContent-leave-to {
        opacity: 0;
        // transform: translateX(30px);
    }

    .mt32 {
        margin: 32px auto 0 auto !important;
    }

    .mt20 {
        margin: 20px auto 0 auto !important;
    }

    .wid10 {
        display: inline-block;
        width: 112px;
        height: auto;
    }

    .mr16 {
        margin-right: 16px;
    }

    .wire {
        width: 686px;
        height: 2px;
        background: #f5f5f5;
        margin: 48px auto 32px;
    }

    .m32-48 {
        margin: 32px auto 48px !important;
    }

    .dot {
        width: 8px;
        height: 8px;
        background: #74b176;
        border-radius: 100%;
        margin: 0 8px;
    }
    .dot2{
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 100%;
        margin: 0 8px;
    }

    .hei16 {
        width: 100%;
        height: 16px;
    }

    .top2solid {
        border-top: 2px solid #eaeaea;
    }

    .hei32 {
        width: 100%;
        height: 32px;
    }

    .main {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 100px;
        background: #ffffff;

        .main-title {
            position: relative;
            width: 684px;
            height: 100px;
            font-size: 36px;
            line-height: 50px;
            text-indent: 164px;

            .main-title-p {
                position: absolute;
                top: 3px;
                left: 0;
                width: 154px;
                height: 40px;
                background: #45add9;
                border-radius: 106px;
                font-size: 24px;
                color: #ffffff;
                display: flex;
                justify-content: center;
                align-items: center;
                text-indent: 0;
            }
        }

        .main-project-type {
            width: 684px;
            height: auto;
            margin: auto;

            .main-project-type-content {
                width: 100%;
                height: auto;

                span {
                    font-size: 24px;

                    &:nth-child(1) {
                        color: #a3a3a3;
                    }

                    &:nth-child(2) {
                        color: #3d3c4f;
                    }
                }
            }
        }

        .main-project-team {
            width: 684px;
            height: auto;
            margin: 32px auto 0;
            display: flex;
            color: #333333;
            font-size: 24px;
            font-weight: 500;

            div {
                width: 32px;
                height: 32px;
                // background: pink;
                background: url("../../../../assets/images/archives/dossier/team_icon.png") no-repeat;
                background-size: 35px 35px;
                margin-right: 16px;
            }
        }

        .main-project-evaluate {
            width: 686px;
            height: 80px;
            background: #f3f6ff;
            border-radius: 16px;
            margin: 32px auto 0;
            display: flex;
            align-items: center;
            padding: 0 32px;

            span {
                font-size: 24px;

                &:nth-child(1) {
                    display: inline-block;
                    color: #333333;
                    font-weight: 500;
                    margin-right: 16px;
                }
            }
        }

        .main-project-evaluate-label {
            width: 684px;
            height: 64px;
            margin: 32px auto 0;
            overflow-x: scroll;
            display: flex;

            div {
                min-width: 150px;
                height: 64px;
                border-radius: 16px 16px 16px 16px;
                opacity: 1;
                border: 2px solid #0d53fc;
                color: #0d53fc;
                font-size: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 28px;
            }
        }

        .main-project-facility {
            width: 686px;
            // height: 304px;
            background: #f3f6ff;
            border-radius: 16px;
            margin-top: 32px;

                .service-box {
                    width: 100%;
                    height: 206px;
                    border-bottom: 2px solid #ffffff;
                    padding: 32px;
                    font-size: 24px;
                    color: #3d3c4f;
                    overflow: hidden;

                    span {
                        display: inline-block;

                        &:nth-child(odd) {
                            color: #a3a3a3;
                        }

                        &:nth-child(7),
                        &:nth-child(4) {
                            margin-top: 20px;
                        }
                    }
                }

                .device-box {
                    display: flex;
                    align-items: center;
                    padding: 0 32px 18px 32px;
                    flex-wrap: wrap;

                    div {
                        border-bottom: 0;
                        padding: 0;
                        margin: 18px 48px 0 0;
                        font-size: 24px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
        }

        .solve {
            width: 686px;
            height: 64px;
            padding: 0 150px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 32px;

            div {
                width: 176px;
                height: 64px;
                border-radius: 80px;
                font-size: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .solve-project {
            width: 686px;
            height: 64px;
            background: #83a6fb;
            display: flex;
            padding: 0 30px;
            align-items: center;

            span {
                font-size: 24px;

                &:nth-child(1) {
                    color: #fff;
                }

                &:nth-child(2) {
                    color: #b9ccfb;
                    margin-left: auto;
                    margin-right: 32px;
                }
            }
        }

        .solve-project-content {
            width: 686px;
            height: auto;
            background: #f9f9fb;

            .solve-project-content-title {
                width: 100%;
                height: 72px;
                background: #f3f6ff;
                box-shadow: 0px 2px 0px #eaeaea;
                padding-right: 32px;
                display: flex;
                align-items: center;

                div {
                    &:nth-child(1) {
                        width: 4px;
                        height: 26px;
                        background: #0d53fc;
                    }

                    &:nth-child(2) {
                        width: auto;
                        height: 40px;
                        color: #0d53fc;
                        font-size: 28px;
                        margin-left: 28px;
                    }

                    &:nth-child(3) {
                        width: fit-content;
                        height: 40px;
                        border-radius: 50px;
                        margin-left: auto;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                    }
                }
            }

            .solve-project-content-content {
                width: 100%;
                height: auto;
                font-size: 24px;
                color: #333333;
                display: flex;
                flex-direction: column;
                padding: 22px 0 16px 32px;
                justify-content: space-between;

                span {
                    margin-bottom: 16px;
                }
            }
        }
    }
</style>
